import { useEffect, useState } from 'react';
import { Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import api from '@/lib/api';

export const LetterEmailDialog = ({ letter, onClose }) => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => setEmail(letter?.recipient_email || ''), [letter]);

  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post(`/admin/documents/${letter.id}/send-email`, { email });
      toast.success(data.message || 'Brief gesendet');
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'E-Mail konnte nicht gesendet werden');
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={!!letter} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="letter-email-dialog">
        <DialogHeader>
          <DialogTitle>Brief per E-Mail senden</DialogTitle>
        </DialogHeader>
        {letter && (
          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              <strong>{letter.subject}</strong> ({letter.document_number}) wird als PDF-Anhang verschickt.
            </p>
            <div>
              <Label className="text-xs">E-Mail-Adresse des Empfängers</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="kunde@beispiel.de" data-testid="letter-email-input" />
            </div>
            <div className="flex gap-3">
              <Button variant="outline" className="flex-1" onClick={onClose}>Abbrechen</Button>
              <Button className="flex-1 bg-[#9B1B30] hover:bg-[#7a1526] text-white" disabled={!email.includes('@') || sending} onClick={send} data-testid="letter-email-send-btn">
                {sending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />} Senden
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LetterEmailDialog;
